<template>
  <div class="card">
    <footer class="card-footer">
      <a
        @click="signNewDocument"
        class="card-footer-item"
      >
        {{ $t('components.signingSteps.endingStep.signNewDocumentButton') }}

      </a>
      <a
        @click="logout"
        class="card-footer-item"
      >
        <span>
          <strong>
            <span v-if="getLocale() === 'el'">
              {{ getGreekName(getToken()) }}&nbsp;&#183;
            </span>
            <span v-else>
              {{ getLatinName(getToken()) }}&nbsp;&#183;
            </span>
          </strong>
          &nbsp;
          {{ $t('components.signingSteps.endingStep.logoutButton') }}
        </span>

        <b-icon icon="logout">
        </b-icon>
      </a>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { tokenUtils } from '@/mixins/tokenUtils'

export default {
  name: 'EndingStep',
  mixins: [tokenUtils],
  methods: {
    ...mapActions([
      'logout'
    ]),
    ...mapGetters([
      'getLocale',
      'getToken'
    ]),
    signNewDocument () {
      this.$emit('newDocumentSigning')
    }
  }
}
</script>
